export default __webpack_public_path__ + "static/media/completed-task.84984eff.svg";